import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild,
} from "@angular/core";
import { MatCheckbox } from "@angular/material/checkbox";
import {
    MatSlideToggle,
    MatSlideToggleChange,
} from "@angular/material/slide-toggle";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { PersonaDTO } from "app/main/apps/shared/interfaces/persona.interface";
import { ContratistaDTO } from "app/main/apps/shared/models/contratista.model";
import { ContratistaService } from "app/main/apps/shared/services/rest/contratista.service";
import { UsuarioService } from "app/main/apps/shared/services/rest/usuario.service";

import { MenuUsuarioService } from "app/main/apps/shared/services/util/menu-usuario.service";
import { Subscription } from "rxjs";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
    selector: "app-identificacion",
    templateUrl: "./identificacion.component.html",
    styleUrls: ["./identificacion.component.scss"],
})
export class IdentificacionComponent implements OnInit, OnDestroy {
    @Input() contratista: ContratistaDTO;
    @Input() eliminado: boolean;
    @Input() esModal: boolean;
    @Output()
    eliminarContratista: EventEmitter<ContratistaDTO> = new EventEmitter();
    @Output()
    editarContratista: EventEmitter<ContratistaDTO> = new EventEmitter();

    @ViewChild("checkActivacion", { static: false })
    slideActivacion: MatSlideToggle;

    subscripciones: Subscription;

    fotoPerfil: SafeUrl;

    constructor(
        public _menuUsuarioSrvc: MenuUsuarioService,
        private _contratistaSrvc: ContratistaService,
        private _usuarioSrvc: UsuarioService,
        private sanitizer: DomSanitizer
    ) {
        this.subscripciones = new Subscription();
    }

    ngAfterViewInit() {
        this.buscarFotoPerfil();
        //console.log(this.slideActivacion);
        /*setTimeout(() => {
            if (this._menuUsuarioSrvc.esSupervisor()) {
                this.evaluaActivacion();
            }
        });*/

        this.subscripciones.add(
            this._contratistaSrvc.contratistaChanged$
                .pipe(distinctUntilChanged())
                .subscribe((resp) => {
                    this.contratista = resp;
                    this.evaluaActivacion();
                    //console.log(this.contratista);
                    //console.log("llego");
                })
        );
    }

    async buscarFotoPerfil() {
        this._usuarioSrvc
            .fetchFoto(this.contratista.codigoFoto)
            .subscribe((blob) => {
                let url = window.URL.createObjectURL(blob);
                //console.log(url);
                this.fotoPerfil = this.sanitizer.bypassSecurityTrustUrl(url);
            });
    }

    evaluaActivacion() {
        //console.log("activo", { ...this.contratista }.activo);
        this.slideActivacion.checked = { ...this.contratista }.activo;
    }

    ngOnInit(): void {
        //console.log(this.contratista);
    }

    toggleActivacion(event: MatSlideToggleChange) {
        //console.log(event.checked);
        //console.log(this.slideActivacion);
        this.eliminarContratista.emit(this.contratista);
    }

    editar() {
        this.editarContratista.emit(this.contratista);
    }

    ngOnDestroy() {
        this.subscripciones.unsubscribe();
    }
}
